module.exports = __webpack_public_path__ + "static/thumb-b5ddf4c928d26c4b4a3b9f0515ad3073.png";